import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const CurrencySigma = createSvgIcon(
  <svg width="249" height="271" viewBox="0 0 249 271" fill="none">
    <g fill="currentColor">
      <path d="M248.317 67.6617L248.328 22.6847L204.598 0.191162L161.274 22.4632L160.855 22.6746V67.6517L204.586 90.1351L248.317 67.6617Z" />
      <path d="M219.163 212.312L219.175 118.64H219.129L197.533 130.044L176.086 118.723L176.075 189.556L109.822 224.522L43.5806 189.535L43.592 119.572L110.543 84.2391V38.7383L0.503638 96.8265L0.492188 212.28L109.822 270.023L219.163 212.312Z" />
    </g>
  </svg>,
  'CurrencySigma'
);
